import { EventObject } from '@xstate/store-react';
import { StoreContext } from '../../../models/store/context';
import { StoreEvent } from '../../../enums/storeEvent';
import { CpgData } from '../../../models/services/api/getCpgFinder';
import { log } from '@domgen/shared/src/utils/log';

/**
 * Stores CPG finder payload on confirmation state.
 *
 * @param context Current store context.
 * @param event Event containing CPG data.
 * @returns Updated context with CPG data.
 */
export const setCpgData = <T extends EventObject = EventObject>(
  context: StoreContext,
  event: T & { data: CpgData },
): StoreContext => {
  log.debug({ message: StoreEvent.SET_CPG_DATA, data: event.data });
  return {
    ...context,
    confirmation: {
      ...context.confirmation,
      cpgData: event.data,
    },
  };
};
